module.exports = __webpack_public_path__ + "img/forestDetailCo2.f2e0e95d.svg";